import React, { useContext, useState , useEffect} from 'react'
import Language  from '../../Context/Language';
import { PieChart } from 'react-minimal-pie-chart';
import DataFetch  from '../../Context/DataFetch';




export default function Performans() {

    const dataLang = useContext(Language);
    const {PointTable} = useContext(DataFetch)
    const {data} = useContext(DataFetch)
    const {HomeLastMatchData , AwayLastMatchData} = useContext(DataFetch)
    const [isVisible, setIsVisible] = useState(true);
    const [height, setHeight] = useState(0)



    useEffect(() => {   
      window.addEventListener("scroll", listenToScroll);
      return () => 
         window.removeEventListener("scroll", listenToScroll); 
    }, [])

    const listenToScroll = () => {
      let heightToHideFrom = 0;
      const winScroll = document.body.scrollTop || 
          document.documentElement.scrollTop;
      setHeight(winScroll);

  
      if (winScroll > heightToHideFrom) {  
        sessionStorage.setItem("scrolldown",true)
           isVisible && setIsVisible(false);
      } else {
           setIsVisible(true);
      }  
    };

    const AverageMatchPerHome =  (Goal , Match) => {
      return  (Goal / (Match)).toFixed(2)
    }


      return (
        PointTable.length !== 0 ?
        <div className='PerformansContainer'>
        <div id='SlideDownDiv' className='PerformansHeader'><div className='PerformansHeaderText'>{dataLang[sessionStorage.getItem("lang")].Performance}</div></div>
        <div className='PerformansTeamsArea'>

        <div  className='HomeTeamPerformansDisplay'>

          {


              PointTable.filter(name => name.teamId === data.homeTeamId).map((filteredName , i) => (

                filteredName.winsTotal === 0  &&  filteredName.drawsTotal ===0 && filteredName.lossesTotal ===0 ?
                <div key={i} className='HomeTeamPerformans'>
                <div className='firstMatchNew'>{dataLang[sessionStorage.getItem("lang")].FIRSTMATCHOFTHENEWSEASON}</div>
                </div>
                :



                <div key={i} className='HomeTeamPerformans'>

              {/* <Chart options={dataHome.options} className="PerformansSwitch" series={dataHome.series} type="pie"   /> */}

              <div className='HomeTeamChartsDiv'>
                  <div  className='HomeTeamChartsTexts'>
                    <div className='ColorHomeTexts'><div className='GreenHomeTeamTexts'></div><div className='TeamTexts'><div>{dataLang[sessionStorage.getItem("lang")].Win}</div>:<div>{filteredName.winsTotal}</div></div></div>
                    <div className='ColorHomeTexts'><div className='GrayHomeTeamTexts'></div><div className='TeamTexts'><div>{dataLang[sessionStorage.getItem("lang")].Drawn}</div>:<div>{filteredName.drawsTotal}</div></div></div>
                    <div className='ColorHomeTexts'><div className='RedHomeTeamTexts'></div><div className='TeamTexts'><div>{dataLang[sessionStorage.getItem("lang")].Lost}</div>:<div>{filteredName.lossesTotal}</div></div></div>
                  </div>
                  {
                        PointTable.filter(name => name.teamId === data.homeTeamId).map((filteredName , i) => (
                          <PieChart key={i}
                          label={({ dataEntry }) =>  dataEntry.percentage ===0 ? `` :`${Math.round(dataEntry.percentage)} %`}
                          animate={true}
                          paddingAngle={1}
                          data={[
                                 { title: 'Win', value: filteredName.winsTotal, color: '#006400' },
                                  { title: 'Lost', value: filteredName.lossesTotal, color: '#D2042D' },
                                    { title: 'Drawn', value: filteredName.drawsTotal, color: '#808080' },
                                      ]}
                                       />
                        ))
                  }
           
              </div>
         
          <div className='HomeTeamPerformansAttribute '>
              {/* <div className='HomeTeamPerformansGoalsTexAreat'><img width={20} src='./football-ball.png'></img><div className='HomeTeamPerformansGoalsText'>Goals</div></div> */}
             
             {
               HomeLastMatchData.length !==0  ?
               <div className="containerbx">
                <div className="bx-pager bx-default-pager">
                {
                      HomeLastMatchData.map(function(item, i){ 
                         return  item.winner_Id === 0 ?

                         <div key={i} className="bx-pager-item">
                         <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].D}</div>
                           <div className="arrow">
                          </div>
                        </div>

                        :
                        item.winner_Id === data.homeTeamId ?
                        <div key={i} className="bx-pager-item green">
                        <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].W}</div>
                          <div className="arrow">
                         </div>
                       </div>

                       :
                       <div key={i} className="bx-pager-item red ">
                       <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].L}</div>
                         <div className="arrow">
                        </div>
                      </div>

                           })
                }
                 </div>
             
                  </div> 
               :""
             }
              
            
              <div className='GoalsStaticArea'>
                  <div className='GoalStaticArea'><div className='GoalStatic'><span className='GoalStaticDivText'>{dataLang[sessionStorage.getItem("lang")].GoalForward}</span></div><span className='GoalStaticText'>{filteredName.goalsTotal.split(":")[0]}</span></div>
                  <div className='GoalStaticArea'><div className='GoalStatic'><span className='GoalStaticDivText'>{dataLang[sessionStorage.getItem("lang")].GoalAgainst}</span></div><span className='GoalStaticText'>{filteredName.goalsTotal.split(":")[1]}</span></div>
                  <div className='GoalStaticArea'><div className='GoalStatic'><span className='GoalStaticDivText'>{dataLang[sessionStorage.getItem("lang")].AverageGoalMatch}</span></div><span className='GoalStaticText'>{AverageMatchPerHome(filteredName.goalsTotal.split(":")[0] , filteredName.playedTotal)}</span></div>
              </div>
          </div>
               
          </div>
             
                    ))
          }
            </div>

            <div className='AwayTeamPerformansDisplay'>

          {
             
                    PointTable.filter(name => name.teamId === data.awayTeamId).map((filteredName , i) => (
                      filteredName.winsTotal === 0  &&  filteredName.drawsTotal ===0 && filteredName.lossesTotal ===0 ?
                      <div key={i} className='AwayteamPerformans'>
                      <div className='firstMatchNew'>{dataLang[sessionStorage.getItem("lang")].FIRSTMATCHOFTHENEWSEASON}</div>
               </div>
               :
                    <div key={i} className='AwayteamPerformans'>
                                 <div className='HomeTeamChartsDiv'>
              <div className='HomeTeamChartsTexts'>
                <div className='ColorHomeTexts'><div className='GreenHomeTeamTexts'></div><div className='TeamTexts'><div>{dataLang[sessionStorage.getItem("lang")].Win}</div>:<div>{filteredName.winsTotal}</div></div></div>
                <div className='ColorHomeTexts'><div className='GrayHomeTeamTexts'></div><div className='TeamTexts'><div>{dataLang[sessionStorage.getItem("lang")].Drawn}</div>:<div>{filteredName.drawsTotal}</div></div></div>
                <div className='ColorHomeTexts'><div className='RedHomeTeamTexts' ></div><div className='TeamTexts'><div>{dataLang[sessionStorage.getItem("lang")].Lost}</div>:<div>{filteredName.lossesTotal}</div></div></div>
              </div>

              {
                PointTable.filter(name => name.teamId === data.awayTeamId).map((filteredName , i) => (
                  <PieChart key={i}
              
                  label={({ dataEntry }) =>  dataEntry.percentage ===0 ? `` :`${Math.round(dataEntry.percentage)} %`}
                  animate={true}
                  paddingAngle={1}
                  data={[
                         { title: 'Win', value: filteredName.winsTotal, color: '#006400' },
                          { title: 'Drawn', value: filteredName.drawsTotal, color:  '#808080' },
                            { title: 'Lost', value: filteredName.lossesTotal, color:    '#D2042D'},
                              ]}
                               />
                ))
              }
            
              </div>

                     <div className='HomeTeamPerformansAttribute '>

                     {
               AwayLastMatchData.length !==0  ?
               <div className="containerbx">
                <div className="bx-pager bx-default-pager">
                {
                      AwayLastMatchData.map(function(item, i){
                         return  item.winner_Id === 0 ?

                         <div key={i} className="bx-pager-item ">
                         <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].D}</div>
                           <div className="arrow">
                          </div>
                        </div>

                        :
                        item.winner_Id === data.awayTeamId ?
                        <div key={i} className="bx-pager-item green">
                        <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].W}</div>
                          <div className="arrow">
                         </div>
                       </div>

                       :
                       <div key={i} className="bx-pager-item red ">
                       <div className="bx-pager-link ">{dataLang[sessionStorage.getItem("lang")].L}</div>
                         <div className="arrow">
                        </div>
                      </div>

                           })
                }
                 </div>
             
                  </div> 
               :""
             }
              
                            {/* <div className='HomeTeamPerformansGoalsTexAreat'><img width={20} src='./football-ball.png'></img><div className='HomeTeamPerformansGoalsText'>Goals</div></div> */}
                            <div className='GoalsStaticArea'>
                                <div className='GoalStaticArea'><div className='GoalStatic'><span className='GoalStaticDivText'>{dataLang[sessionStorage.getItem("lang")].GoalForward}</span></div><span className='GoalStaticText'>{filteredName.goalsTotal.split(":")[0]}</span></div>
                                <div className='GoalStaticArea'><div className='GoalStatic'><span className='GoalStaticDivText'></span>{dataLang[sessionStorage.getItem("lang")].GoalAgainst}</div><span className='GoalStaticText'>{filteredName.goalsTotal.split(":")[1]}</span></div>
                                <div className='GoalStaticArea'><div className='GoalStatic'><span className='GoalStaticDivText'>{dataLang[sessionStorage.getItem("lang")].AverageGoalMatch}</span></div><span className='GoalStaticText'>{AverageMatchPerHome(filteredName.goalsTotal.split(":")[0] , filteredName.PlayedTotal)}</span></div>
                            </div>
                        </div>
                    </div>
                                 ))
                                
            }
            </div>
        </div>
    </div>
    :
    ""
      )
}







